import { IItem, instanceOfIItem } from "./IItem";
import { SelectionModeKinds } from "../SelectionModeKinds";
import { UserDefinitionWindowKinds } from "../UserDefinitionWindowKinds";
import { SeparatorKinds } from "../SeparatorKinds";
import { RelationalActionParameter } from "./RelationalActionParameter";

export interface IUserDefinitionItem extends IItem {
  userDefinitionKey: string;
  itemName: string;
  groupName: string;
  userDefinitionSelectionMode: SelectionModeKinds;
  userDefinitionWindowKind: UserDefinitionWindowKinds;
  separatorKind: SeparatorKinds;
  setUserDefinitionValues(values: string[]): void;
  changeInputMethodExceptUserDefinitionSelect(): void;
  adjustFontSize(): void;
  adjustObjectHeight(): void;
  userDefineLinkActions: RelationalActionParameter[];
  userDefineSearchActions: RelationalActionParameter[];
  setUserDefinitionLinkValues(values: string[]): void;
}

export function instanceOfIUserDefinitionItem(instance: any): instance is IUserDefinitionItem {
  return instance
    && instance.userDefinitionKey
    && instance.itemName
    && (instance.setUserDefinitionValues !== undefined)
    && (instance.changeInputMethodExceptUserDefinitionSelect !== undefined)
    && (instance.adjustFontSize !== undefined)
    && (instance.adjustObjectHeight !== undefined)
    && (instance.userDefineLinkActions !== undefined)
    && (instance.userDefineSearchActions !== undefined)
    && (instance.setUserDefinitionLinkValues !== undefined)
    && instanceOfIItem(instance);
}
